class Button {
  constructor() {
    this.icons = {
      menu: {
        de: '/themes/custom/sanarenatheme26/images/icons/menu.svg',
        en: '/themes/custom/sanarenatheme26/images/icons/menu.svg'
      },
      cross: '/themes/custom/sanarenatheme26/images/icons/cross.svg'
    };
  }

  create(target, status = 'menu', language = 'de') {
    let element = (document && document.createElement('div')) || null;

    if (!element) {
      return null;
    }

    element = this.setElementStyles(element, status, language);
    target.append(element);
    return element;
  }

  onTabOrClick(element, selector) {
    const target = document.querySelector(selector) || null;

    if (!target) {
      return null;
    }

    element.addEventListener('click', () => {
      target.classList.toggle('menu--main__overlay__show');
    });

    return element;
  }

  setElementStyles(element, status, language) {
    Object.assign(element.style, {
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      position: 'fixed',
      top: '20px',
      right: '20px',
      width: '50px',
      height: '50px',
      margin: '0 0 0 auto'
    });

    switch (status) {
      case 'cross':
        element.style.backgroundColor = '#ffffff';
        element.style.maskImage = `url('${this.icons[status]}')`;
        element.style.zIndex = '2000';
        break;
      default:
        element.style.backgroundColor = '#003dbb';
        element.style.maskImage = `url('${this.icons.menu[language]}')`;
        element.style.zIndex = '100';
    }

    return element;
  }
}

export default Button;
